import { white, red } from "../element/text/link.js";
import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/postcss/lib/postcss.js";
import "../node_modules/postcss-js/index.js";
import "../node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const linksDark = {
  className: `umd-animation-links-dark`,
  "& a": {
    ...white
  }
};
const linksWhite = {
  className: `umd-animation-links-white`,
  "& a": {
    ...red
  }
};
const gridSetup = objectWithClassName({
  "& > *": {
    [`@media (prefers-reduced-motion: no-preference)`]: {
      opacity: "0",
      transform: "translateY(50px)"
    }
  },
  className: [
    `umd-animation-grid`,
    /** @deprecated Use 'umd-animation-grid' instead */
    "umd-grid-animation"
  ]
});
export {
  gridSetup,
  linksDark,
  linksWhite
};
//# sourceMappingURL=nested-elements.js.map
